import { Table } from '@/components/client_type/table'

export const ClientTypes = () => {
  return (
    <>
      <Table pageSize={20} createable onIndex />
    </>
  )
}
